<template>
  <div class="ml-2" v-if="configuracion_envios">
    <div class="d-inline-block">
      <ValidationObserver ref="validationObserver">
        <v-form ref="form" lazy-validation class="pa-1">
          <!-- Remitente -->
          <v-row class="ma-0 mt-3">
            <v-col cols="12" class="pa-0">
              <ValidationProvider rules="required|max:11"
                                  :name="$t('Remitente').toLowerCase()"
                                  v-slot="{ errors, classes }"
              >
                <div class="control" :class="classes">

                  <v-text-field
                      hide-details
                      v-model="configuracion_envios.sender_name"
                      :label="$t('Remitente')"
                      outlined
                      dense
                  ></v-text-field>
                </div>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
          </v-row>

          <!-- Recordatorio de cita 24h antes de la misma -->
          <v-row class="ma-0 mt-3">
            <v-col cols="12" class="pa-0">
              <v-switch
                  :label="$t('Recordatorios de citas 24 horas antelación')"
                  dense
                  hide-details
                  v-model="configuracion_envios.is_recordatorio_cita" />
            </v-col>

            <!-- Texto del recordatorio de cita 24h antes de la misma -->
            <v-col cols="12" class="pa-0" v-if="configuracion_envios.is_recordatorio_cita">
              <!-- Mensaje informativo para aclarar el concepto -->
              <div class="container_info_azul">
                <p>{{ $t('Las palabras %(cliente)s, %(centro)s, %(fecha)s, %(hora)s y %(telefono)s serán sustituidas en el SMS por el nombre del cliente, nombre de su centro, fecha de la cita, hora de la cita y teléfono de su centro.') }}</p>
                <p>{{ $t('En el ejemplo: %(cliente)s le recordamos que tiene cita con %(centro)s el %(fecha)s a las %(hora)s. Si no puede acudir por favor llame al %(telefono)s. El cliente recibiría: Juan le recordamos que tiene cita con Koibox SL el 31/01/2020 a las 09:00. Si no puede acudir por favor llame al 960112233.') }}</p>
              </div>

              <ValidationProvider rules="required"
                                  :name="$t('Texto SMS').toLowerCase()"
                                  v-slot="{ errors, classes }"
              >
                <div class="control" :class="classes">

                  <v-text-field
                      :label="$t('Texto SMS')"
                      v-model="configuracion_envios.texto_recordatorio_cita"
                      dense
                      outlined
                      hide-details
                  />
                </div>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
          </v-row>

          <!-- SMS de confirmacion instantanea de la cita -->
          <v-row class="ma-0 mt-3">
            <v-col cols="12" class="pa-0">

              <v-switch
                  :label="$t('Confirmación instantánea de citas')"
                  dense
                  hide-details
                  v-model="configuracion_envios.is_confirmar_cita" />
            </v-col>

            <!-- Texto del SMS de confirmacion instantanea de la cita -->
            <v-col cols="12" class="pa-0" v-if="configuracion_envios.is_confirmar_cita">
              <!-- Mensaje informativo para aclarar el concepto -->
              <div class="container_info_azul">
                <p>{{ $t('Las palabras %(cliente)s, %(centro)s, %(fecha)s, %(hora)s y %(telefono)s serán sustituidas en el SMS por el nombre del cliente, nombre de su centro, fecha de la cita, hora de la cita y teléfono de su centro.') }}</p>
                <p>{{ $t('En el ejemplo: %(cliente)s le confirmamos que tiene cita con %(centro)s el %(fecha)s a las %(hora)s. Si no puede acudir por favor llame al %(telefono)s. El cliente recibiría: Juan le confirmamos que tiene cita con Koibox SL el 31/01/2020 a las 09:00. Si no puede acudir por favor llame al 960112233.') }}</p>
              </div>

              <ValidationProvider rules="required"
                                  :name="$t('Texto SMS').toLowerCase()"
                                  v-slot="{ errors, classes }"
              >
                <div class="control" :class="classes">

                  <v-text-field
                      :label="$t('Texto SMS')"
                      v-model="configuracion_envios.texto_confirmacion_cita"
                      dense
                      outlined
                      hide-details
                  />
                </div>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
          </v-row>

          <!-- Teléfono modificar cita -->
          <v-row class="ma-0 mt-3">
            <v-col cols="12" class="pa-0">
              <ValidationProvider rules="required|integer|max:13"
                                  :name="$t('Teléfono modificar cita').toLowerCase()"
                                  v-slot="{ errors, classes }"
              >
                <div class="control" :class="classes">
                  <v-text-field
                      hide-details
                      v-model="configuracion_envios.telefono_modificar_cita"
                      :label="$t('Teléfono modificar cita')"
                      outlined
                      type="number"
                      dense
                  />
                </div>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
          </v-row>


          <!-- SMS de enviar encuestas post cita -->
          <v-row class="ma-0 mt-3">
            <v-col cols="12" class="pa-0">
              <v-switch
                  :label="$t('Encuestas')"
                  dense
                  hide-details
                  v-model="configuracion_envios.is_encuestas" />
            </v-col>
          </v-row>


          <!-- SMS a clientes en lista de espera -->
          <v-row class="ma-0 mt-3">
            <v-col cols="12" class="pa-0">
              <v-switch
                  :label="$t('Clientes en lista de espera')"
                  dense
                  hide-details
                  v-model="configuracion_envios.is_notificaciones_lista_espera" />
            </v-col>
          </v-row>

          <!-- SMS de felicitaciones a los clientes -->
          <v-row class="ma-0 mt-3">
            <v-col cols="12" class="pa-0">
              <v-switch
                  :label="$t('Felicitaciones cumpleaños SMS')"
                  dense
                  hide-details
                  v-model="configuracion_envios.is_cumpleanios" />
            </v-col>

            <v-col cols="12" class="pa-0" v-if="configuracion_envios.is_cumpleanios">
              <!-- Mensaje informativo para aclarar el concepto -->
              <div class="container_info_azul">
                <p>{{ $t("Las palabras %(cliente)s y %(centro)s serán sustituidas por el nombre del cliente y de su centro.") }}</p>
                <span>{{ $t("En el ejemplo: FELICIDADES %(cliente)s! %(centro)s le desea un feliz día de cumpleaños!. El cliente recibiría: FELICIDADES Juan! Koibox SL le desea un feliz día de cumpleaños!") }}</span>
              </div>

              <ValidationProvider rules="required"
                                  :name="$t('Texto SMS').toLowerCase()"
                                  v-slot="{ errors, classes }"
              >
                <div class="control" :class="classes">

                  <v-text-field
                      :label="$t('Texto SMS')"
                      v-model="configuracion_envios.texto_cumpleanios"
                      dense
                      outlined
                      hide-details
                  />
                </div>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
          </v-row>



          <!-- SMS a clientes perdidos -->
          <v-row class="ma-0 mt-3">
            <v-col cols="12" class="pa-0">
              <v-switch
                  :label="$t('Clientes perdidos')"
                  dense
                  hide-details
                  v-model="configuracion_envios.is_clientes_perdidos" />
            </v-col>

            <v-col cols="12" class="pa-0" v-if="configuracion_envios.is_clientes_perdidos">
              <!-- Mensaje informativo para aclarar el concepto -->
              <div class="container_info_azul">
                <p>{{ $t('La palabra %(cliente)s será sustituida en el SMS por el nombre del cliente.') }}</p>
                <p>{{ $t('En el ejemplo: %(cliente)s, le echamos de menos!. El cliente recibiría: Juan, le echamos de menos!') }}</p>
              </div>

              <ValidationProvider rules="required"
                                  :name="$t('Texto SMS').toLowerCase()"
                                  v-slot="{ errors, classes }"
              >
                <div class="control" :class="classes">

                  <v-text-field
                      :label="$t('Texto SMS')"
                      v-model="configuracion_envios.texto_clientes_perdidos"
                      dense
                      outlined
                      hide-details
                  />
                </div>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
          </v-row>

        </v-form>
      </ValidationObserver>
    </div>

    <!-- Boton de guardar datos -->
    <v-btn color="primary" class="mt-4" block small @click="save">
      <v-icon small>mdi-content-save</v-icon>
      <span class="ml-1">{{ $t('Guardar') }}</span>
    </v-btn>

    <FormComprarBonos v-if="comprar_bonos"
                      v-model="comprar_bonos"
    />
  </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from 'vee-validate';

export default {
  name: "ConfiguracionEnviosSMS",

  data: function(){
    return {
      comprar_bonos: false
    }
  },

  props: {
    configuracion_envios: {
      type: Object,
      required: true
    }
  },

  methods: {

    async save(){
      const form_valid = await this.$refs.validationObserver.validate()
      if(form_valid){
        this.$emit('on_click_save')
      }
    },

    open_dialog_comprar_bonos() {
      this.comprar_bonos = true
    },
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    FormComprarBonos: () => import('@/views/Marketing/components/FormComprarBonos')
  }
}
</script>